/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

// ====
const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};
// ====

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message: '',
      feedbackClass: null,
      feedbackMessage: null,
      formVisibility: true,
    };
  }

  handleSubmit = (e) => {
    console.dir(e.target);

    if (e.target.checkValidity() === true) {
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({ 'form-name': 'AjaxContact', ...this.state }),
      })
        .then((response) => {
          if (response.ok === true) {
            this.setState({
              feedbackClass: 'alert-success',
              feedbackMessage: 'Your message has been sent',
              formVisibility: false,
            });
          } else {
            this.setState({
              feedbackClass: 'alert-warning',
              feedbackMessage:
                'Sorry, there was a technical problem sending your message - please try again [Code: 02]',
            });
          }
        })
        .catch((error) => {
          this.setState({
            feedbackClass: 'alert-warning',
            feedbackMessage:
              'Sorry, there was a technical problem sending your message - please try again [Code: 03]',
          });
        });
    } else {
      event.preventDefault();
      event.stopPropagation();
      e.target.classList.add('was-validated');
      this.setState({
        feedbackClass: 'alert-danger',
        feedbackMessage: 'There are items that require your attention',
      });
    }

    e.preventDefault();
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { name, email, message } = this.state;

    return (
      <>
        {this.state.feedbackMessage && (
          <div className={`alert ${this.state.feedbackClass}`}>
            {this.state.feedbackMessage}
          </div>
        )}
        {this.state.formVisibility ? (
          <form
            className="needs-validation"
            name="Contact"
            method="POST"
            action="/"
            data-netlify="true"
            netlify-honeypot="honeyhoney"
            onSubmit={(event) => this.handleSubmit(event)}
            noValidate
          >
            <input type="hidden" name="form-name" value="Contact" />
            <input type="hidden" name="honeyhoney" />
            <div className="form-group">
              <label htmlFor="inputName">Your name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={name}
                onChange={this.handleChange}
                aria-label="Enter your name"
                required
              />
              <div className="invalid-feedback">Please enter your name</div>
            </div>
            <div className="form-group">
              <label htmlFor="inputEmail">Email address</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={email}
                onChange={this.handleChange}
                aria-describedby="emailHelp"
                required
              />
              <div className="invalid-feedback">
                Please enter a valid email address
              </div>
              <small id="emailHelp" className="form-text text-muted">
                We'll never share your email with anyone else.
              </small>
            </div>
            <div className="form-group">
              <label htmlFor="inputMessage">Your message</label>
              <textarea
                class="form-control"
                name="message"
                value={message}
                onChange={this.handleChange}
                aria-label="Enter your message"
                placeholder="Message"
                rows="3"
                required
              ></textarea>
              <div className="invalid-feedback">Please enter a message</div>
            </div>
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        ) : (
          <div>
            <div className="form-group">
              <label>Your name:</label> <p>{name}</p>
            </div>
            <div className="form-group">
              <label>Your email:</label> <p>{email}</p>
            </div>
            <div className="form-group">
              <label>Your message:</label> <p>{message}</p>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Form;

// ====

Form.propTypes = {};

Form.defaultProps = {};
